import { useState } from "react";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";

// Alta o edición de una FAQ. Pregunta y respuesta en texto plano.
const ListingFaqForm = ({ initialValues, isSaving, onSubmit, onCancel }) => {
  const [question, setQuestion] = useState(initialValues?.question ?? "");
  const [answer, setAnswer] = useState(initialValues?.answer ?? "");

  const canSave = question.trim() !== "" && answer.trim() !== "" && !isSaving;

  const handleSubmit = (event) => {
    event.preventDefault();
    if (canSave) onSubmit({ question: question.trim(), answer: answer.trim() });
  };

  return (
    <form className="ListingFaqForm" onSubmit={handleSubmit}>
      <label className="ListingFaqForm__field">
        <span>Pregunta</span>
        <InputText
          value={question}
          onChange={(event) => setQuestion(event.target.value)}
          placeholder="¿Cuánto cuesta una vivienda en La Moraleja?"
          autoFocus
        />
      </label>
      <label className="ListingFaqForm__field">
        <span>Respuesta</span>
        <InputTextarea
          value={answer}
          onChange={(event) => setAnswer(event.target.value)}
          rows={5}
          autoResize
        />
      </label>
      <div className="ListingFaqForm__actions">
        <button type="button" className="btn-secondary" onClick={onCancel}>
          Cancelar
        </button>
        <button type="submit" className="btn-primary" disabled={!canSave}>
          {isSaving ? "Guardando..." : "Guardar"}
        </button>
      </div>
    </form>
  );
};

export default ListingFaqForm;
